import React from "react";

const Page = React.forwardRef(({ header, image, text, number }, ref) => {

  return (
    <div className="demoPage" ref={ref}>
      <div className="page-content">
        
        {header ? <h2 className="page-header">{header}</h2> : null}

        {image ? (
          <div className="page-image">
            <img
              src={image}
              alt="Menu Page"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        ) : null}

        {text ? <div className="page-text">{text}</div> : null}
      {/* {number ? <div className="page-footer">{number}</div> : null} */}
      </div>
    </div>
  );
});

export default Page;
